// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireWildcard(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _Text = require('../Text');

var _Select = require('./Select.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

var KeyboardArrowDownIcon = function KeyboardArrowDownIcon(props) {
  return _react.default.createElement(
    'svg',
    props,
    _react.default.createElement('path', {
      d: 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'
    }),
    _react.default.createElement('path', {
      fill: 'none',
      d: 'M0 0h24v24H0V0z'
    })
  );
};

KeyboardArrowDownIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24'
};

var Select =
  /*#__PURE__*/
  (function (_Component) {
    _inherits(Select, _Component);

    function Select(props) {
      var _this;

      _classCallCheck(this, Select);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

      _initialiseProps.call(_assertThisInitialized(_this));

      var _this$props = _this.props,
        open = _this$props.open,
        value = _this$props.value,
        text = _this$props.text,
        multiple = _this$props.multiple;
      _this.state = {
        open: open,
        value: value || (multiple ? [] : value),
        text: text,
        initialValue: value || (multiple ? [] : value)
      };
      return _this;
    }
    /**
     * Handles the click event on the select control
     * @param {Object} event The blur event
     */

    _createClass(Select, [
      {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _this$props2 = this.props,
            children = _this$props2.children,
            name = _this$props2.name,
            placeholder = _this$props2.placeholder,
            disabled = _this$props2.disabled,
            truncate = _this$props2.truncate,
            listPosition = _this$props2.listPosition,
            multiple = _this$props2.multiple,
            color = _this$props2.color,
            borderColor = _this$props2.borderColor,
            width = _this$props2.width,
            className = _this$props2.className,
            id = _this$props2.id;
          var _this$state = this.state,
            open = _this$state.open,
            value = _this$state.value,
            text = _this$state.text;

          var childrenWithEvent = _react.default.Children.map(children, function (child) {
            var clonedChild = _react.default.cloneElement(child, {
              onClick: _this2.onItemSelected,
              selected: multiple ? value.includes(child.props.itemKey) : ''.concat(value) === child.props.itemKey,
              hasCheckbox: multiple
            });

            return clonedChild;
          });

          return _react.default.createElement(
            _Select.StyledSelect,
            {
              id: id,
              className: className,
              name: name,
              width: width,
              disabled: disabled,
              borderColor: borderColor,
              onClick: this.onSelectClick,
              onBlur: this.onSelectBlur,
              value: value
            },
            _react.default.createElement(
              _Text.Text,
              {
                display: 'block',
                color: color,
                truncate: truncate
              },
              text || placeholder
            ),
            _react.default.createElement(
              _Select.StyledSelectIcon,
              {
                open: open,
                color: color
              },
              _react.default.createElement(KeyboardArrowDownIcon, null)
            ),
            open &&
              _react.default.createElement(
                _Select.StyledSelectList,
                {
                  listPosition: listPosition
                },
                childrenWithEvent,
                multiple &&
                  _react.default.createElement(
                    _Select.StyledSelectListButtonsWrapper,
                    {
                      onClick: function onClick(event) {
                        return event.stopPropagation();
                      }
                    },
                    _react.default.createElement(
                      _Select.StyledSelectListActionButton,
                      {
                        onClick: this.onClearSelections,
                        disabled: !value || value.length < 1
                      },
                      _react.default.createElement(_Text.Text, null, 'Clear')
                    ),
                    _react.default.createElement(
                      _Select.StyledSelectListActionButton,
                      {
                        onClick: this.onApplySelections,
                        disabled: !value || value.length < 1
                      },
                      _react.default.createElement(_Text.Text, null, 'Apply')
                    )
                  )
              )
          );
        }
      }
    ]);

    return Select;
  })(_react.Component);
/**
 * Definition of default values for component props
 */

exports.Select = Select;

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelectClick = function (event) {
    var _this3$props = _this3.props,
      disabled = _this3$props.disabled,
      onOpen = _this3$props.onOpen,
      onClose = _this3$props.onClose;
    var _this3$state = _this3.state,
      open = _this3$state.open,
      value = _this3$state.value,
      initialValue = _this3$state.initialValue;

    if (!disabled) {
      _this3.setState({
        open: !open
      });

      if (!open && onOpen) onOpen(event);
      else if (open && onClose) {
        onClose(event);

        _this3.fireOnChange(event, value, initialValue);
      }
    }
  };

  this.onSelectBlur = function (event) {
    var _this3$props2 = _this3.props,
      disabled = _this3$props2.disabled,
      onClose = _this3$props2.onClose;
    var _this3$state2 = _this3.state,
      value = _this3$state2.value,
      initialValue = _this3$state2.initialValue,
      open = _this3$state2.open;

    if (!disabled) {
      _this3.setState({
        open: false
      });

      if (open && onClose) onClose(event);

      _this3.fireOnChange(event, value, initialValue);
    }
  };

  this.onItemSelected = function (event) {
    event.stopPropagation();
    var _this3$props3 = _this3.props,
      disabled = _this3$props3.disabled,
      onClose = _this3$props3.onClose,
      multiple = _this3$props3.multiple;
    var value = _this3.state.value;

    if (!disabled) {
      var newSelectedText = event.currentTarget.innerText;
      var newSelectedValue = event.currentTarget.value;

      if (multiple) {
        if (value.includes(''.concat(newSelectedValue)))
          value = value.filter(function (item) {
            return item !== ''.concat(newSelectedValue);
          });
        else value.push(''.concat(newSelectedValue));

        _this3.setState({
          text:
            value.length > 0
              ? 'You have selected '.concat(value.length, ' ').concat(value.length > 1 ? 'items' : 'item')
              : undefined,
          value: value
        });
      } else {
        _this3.setState({
          text: newSelectedText,
          value: newSelectedValue,
          open: false
        });

        _this3.fireOnChange(event, newSelectedValue, value);

        if (onClose) onClose(event);
      }
    }
  };

  this.onApplySelections = function (event) {
    event.stopPropagation();
    var onClose = _this3.props.onClose;
    var _this3$state3 = _this3.state,
      value = _this3$state3.value,
      initialValue = _this3$state3.initialValue;

    if (value && value.length > 0) {
      _this3.setState({
        open: false
      });

      if (onClose) onClose(event);

      _this3.fireOnChange(event, value, initialValue);
    }
  };

  this.onClearSelections = function (event) {
    var value = _this3.state.value;

    if (value && value.length > 0) {
      event.stopPropagation();

      _this3.setState({
        value: [],
        text: undefined
      });
    }
  };

  this.fireOnChange = function (event, currentValue, initialValue) {
    var onChange = _this3.props.onChange;

    if (onChange && _this3.valueDiff(currentValue, initialValue)) {
      onChange(event, currentValue);

      _this3.setState({
        initialValue: Array.isArray(currentValue) ? currentValue.slice() : currentValue
      });
    }
  };

  this.valueDiff = function (newValue, previousValue) {
    if (Array.isArray(newValue) && Array.isArray(previousValue)) {
      return (
        previousValue.length !== newValue.length ||
        (newValue.length > 0 &&
          previousValue.every(function (item) {
            return !newValue.includes(item);
          }))
      );
    }

    return newValue !== previousValue;
  };
};

Select.defaultProps = {
  children: undefined,
  disabled: false,
  truncate: false,
  listPosition: 'bottom',
  open: false,
  multiple: false,
  placeholder: 'Select an option',
  value: undefined,
  text: undefined,
  color: undefined,
  borderColor: undefined,
  width: undefined,
  className: undefined,
  id: undefined,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onChange: function onChange() {}
};

var singleValueType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
/**
 * Definition of types for component props
 */

Select.propTypes = {
  children: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.oneOfType([
    _propTypes.default.string,
    _propTypes.default.number,
    _propTypes.default.arrayOf(singleValueType)
  ]),
  text: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  truncate: _propTypes.default.bool,
  listPosition: _propTypes.default.oneOf(['top', 'bottom']),
  open: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  color: _propTypes.default.string,
  borderColor: _propTypes.default.string,
  width: _propTypes.default.string,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onChange: _propTypes.default.func
};
